import { Button, Text } from '@components';
import { VariantType } from '@enums';
import type { DualListTransferableRowProps } from '@types';
import { cn, validateValueEqual } from '@utils';

export const DualListTransferableRow = ({
  handleClick,
  handleMouseEvent,
  hoveredContent,
  zone,
  showShortForm,
  value,
  label,
  labelClassName = '',
}: DualListTransferableRowProps) => {
  if (!value && !label) return;
  const isContentHovered = validateValueEqual(hoveredContent, value);
  const isLeftZone = validateValueEqual(zone, 0);
  return (
    <Button
      variant={VariantType.Clean}
      className="justify-between hover:bg-gray-100 w-full rounded-lg px-3.5 py-3 enabled:shadow-none"
      onClick={() => handleClick(value)}
      disabled={!value}
      onMouseEnter={() => handleMouseEvent(value)}
      onMouseLeave={() => handleMouseEvent(null)}
      adornment={
        <>
          {Boolean(label) && (
            <Text $level={5} $customizeColor className={cn('truncate', labelClassName)}>
              {label}
            </Text>
          )}
          {isContentHovered && (
            <Text $level={5} $customizeColor className="text-gray-400">
              {isLeftZone ? '→' : '←'}
            </Text>
          )}
          {Boolean(value) && !isContentHovered && showShortForm && (
            <Text $level={5} $customizeColor className="text-gray-400">
              {value}
            </Text>
          )}
        </>
      }
    />
  );
};
